import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Steps = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.24419 1.4409C7.71124 1.16846 8.28876 1.16846 8.75581 1.4409L13.2558 4.0659C13.7166 4.33472 14 4.82807 14 5.36157V10.6385C14 11.172 13.7166 11.6653 13.2558 11.9341L8.75581 14.5591C8.28876 14.8316 7.71124 14.8316 7.24419 14.5591L2.74419 11.9341C2.28337 11.6653 2 11.172 2 10.6385V5.36157C2 4.82807 2.28337 4.33472 2.74419 4.0659L7.24419 1.4409ZM11.777 4.93982L8 2.73657L4.22301 4.93982L8.00001 7L11.777 4.93982ZM3.5 6.25408L3.5 10.6385L7.25 12.826V8.29954L3.5 6.25408ZM8.75 12.826L12.5 10.6385L12.5 6.25409L8.75 8.29955V12.826Z"
      fill="currentColor"
    />
  </Icon>
));

export default Steps;
